<template>
  <div class="editor-area" ref="editorArea">
    <div id="blocklyDiv" ref="blocklyDiv">

    </div>
  </div>
</template>

<script>
  import Blockly from 'blockly'

  export default {
    name: "BlocklyEditor",
    props: ["visualScript", "toolbox", "showScript"],
    data: function () {
      return {
        workspace: {},
        script: "",
        visualCode: "",
        initialized: false
      }
    },
    watch: {
      toolbox: {
        handler() {
          this.$nextTick(() => {
            if(this.initialized)
              this.workspace.dispose();
            this.initializeBlockly();

            this.initializeListener();
            if(this.visualScript != null && this.visualScript != "")
              Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(this.visualScript), this.workspace);
          });
        },
        immediate: true
      },
      visualScript: {
        handler() {
          if(this.initialized) {
            this.workspace.clear();
            this.initializeListener();
            if(this.visualScript != null && this.visualScript != "")
              Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(this.visualScript), this.workspace);
          }
        },
        immediate: false
      }
    },
    methods: {
      initializeBlockly() {
        this.toolbox.blocks.forEach(block => {
          Blockly.Blocks[block.name] = block.definition;
          Blockly.JavaScript[block.name] = block.codeGenerator(Blockly);
        })

        this.initialized = true;

        this.workspace = Blockly.inject('blocklyDiv',
          {
            //media: 'lib/google-blockly/media',
            toolbox: this.toolbox.xml,
            renderer: 'thrasos'
          });

        var onresize = function(e) {
          var blocklyDiv = this.$refs.blocklyDiv;
          var blocklyArea = this.$refs.editorArea;
          // Compute the absolute coordinates and dimensions of blocklyArea.
          var element = this.$refs.editorArea;
          var x = 0;
          var y = 0;
          do {
            x += element.offsetLeft;
            y += element.offsetTop;
            element = element.offsetParent;
          } while (element);
          // Position blocklyDiv over blocklyArea.
          blocklyDiv.style.left = x + 'px';
          blocklyDiv.style.top = y + 'px';
          blocklyDiv.style.width = blocklyArea.offsetWidth + 'px';
          blocklyDiv.style.height = blocklyArea.offsetHeight + 'px';
          Blockly.svgResize(this.workspace);
        }.bind(this);
        window.addEventListener('resize', onresize, false);
        onresize();

        this.initializeListener();
      },
      initializeListener() {
        let updateScript = () => {
          this.script = Blockly.JavaScript.workspaceToCode(this.workspace);
          this.visualCode = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));
          this.$emit("script-changed", {script: this.script, visualScript: this.visualCode});
        }
        this.workspace.addChangeListener(updateScript);
      }
    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .editor-area {
    height: 800px;
    width: 100%;
  }
</style>
